import React, { useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Button, TextField } from "@material-ui/core";
import MemberList from "../Items/MemberList";
import AddActivity from "../Items/AddActivity";
import MainBox from "../Items/MainBox";
import Apis from "constants/Api";
import ActivitesList from "../Items/ActivitesList";
import StepDesc from "../Items/StepDesc";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

export default function PrepareENGH(props) {
  const [fileName, setFileName] = useState("");

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      props.setStates({ ...props.states, prepareFile: e.target.files[0] });
    } else {
      setFileName("");
    }
  };
  let isUploadedFile =
    typeof props.states.prepareFile === "string" &&
    props.states.prepareFile.length > 0 ? (
      <span>
        یک فایل ثبت شده است:
        <a
          className="fileDownloadButton"
          href={Apis.baseUrl + "media/" + props.states.prepareFile}
        >
          دانلود
        </a>
        <Button onClick={props.deleteFile}>
          <DeleteForeverIcon style={{ color: "#f26868" }} />
        </Button>
      </span>
    ) : (
      ""
    );
  return (
    <MainBox>
      <MemberList
        groupName={props.states.groupName}
        memberList={props.states.memberList}
      />
      <StepDesc>
        تو این مرحله باید کارایی که برای آماده شدن برگزاری مدرسه انقلابتون انجام
        دادید رو بارگذاری کنید. مثلا اگر تو کاردوی شهرستانی بودید اینجا بهترین
        جاست برای ثبت فعالیت و عکس هایی که به یادگار گرفتید.اگر تو کاردو، کاربرگ
        مدرسه انقلاب رو هم پر کردید میتونید اینجا بارگذاریش کنید.همه کارایی که
        برای برپایی و آماده شدن مکان نمایشگاه، محتوا، پوستر ها و... هم کردید جاش
        اینجاست.
      </StepDesc>
      <div className={`uploadingStep flexRow`}>
        <span>بارگذاری کاربرگ نمایشگاه</span>

        <div className="file-upload-container">
          <input
            type="file"
            id="file-upload"
            className="file-input"
            onChange={handleFileChange}
             accept=".pdf, .docx, .txt, .xlsx, .pptx,.jpeg,.jpg,.png"
          />

          <label htmlFor="file-upload" className="file-label">
            انتخاب فایل
          </label>
        </div>
      </div>
      {props.states.prepareFile?.name ? (
        <span className="file-name">
          یک فایل انتخاب شده: {props.states.prepareFile.name}
        </span>
      ) : (
        isUploadedFile
      )}
      <AddActivity
        onClick={props.showModal}
        memberList={props.states.memberList}
        ActivityCounts={props.ActivityCounts}
        goForRefresh={props.goForRefresh}
      />
      <ActivitesList
        step={2}
        activities={props.activities}
        stepActs={props.stepActs}
        refresh={props.refresh}
      />
    </MainBox>
  );
}
